import { gql } from 'apollo-angular';

const GET_MEMBER_RECRUITING_DOWNLOAD = gql`
  query MemberRecruitingDownload($memberId: Long) {
    memberRecruitingDownload(
      memberId : $memberId
    ) {
        url
    }
  }
`;

export default GET_MEMBER_RECRUITING_DOWNLOAD;
